import {type FeatureName} from '@hproduce/suite-core'

export enum RouteSegment {
  EQUIPMENT = 'equipment'
}
export const STOPPAGE_ANALYSIS: FeatureName = 'StoppageAnalysis'

export const EQUIPMENT_SUB_PATH = `${RouteSegment.EQUIPMENT}/:equipmentId`

// Base path for the stoppage analysis sub feature
export const STOPPAGE_ANALYSIS_SUB_PATH = `${STOPPAGE_ANALYSIS}/${EQUIPMENT_SUB_PATH}`
